import { jsx as c } from "@emotion/react/jsx-runtime";
import { DocumentSvg as i } from "./icons/DocumentSvg.js";
import { PhotoSvg as s } from "./icons/PhotoSvg.js";
import { DropzoneTypeEnum as d } from "../../types/components/dropzone.js";
const M = {
  [d.Document]: {
    default: /* @__PURE__ */ c(i, {})
  },
  [d.Photo]: {
    default: /* @__PURE__ */ c(s, {})
  }
}, z = (t) => t < 999 * 1024 ? (t / 1024).toFixed(2) + " Kb" : t < 999 * 1024 * 1024 ? (t / 1048576).toFixed(2) + " Mb" : t + " bytes", g = "min-dimension", f = "max-dimension", w = (t, o) => (p) => p.reduce((r, n) => {
  const {
    width: h,
    height: u
  } = n;
  if (h === void 0 || u === void 0) return r;
  const e = [];
  return (h < t.width || u < t.height) && e.push({
    code: g,
    message: `Your photo must be at least ${t.width}px x ${t.height}px.`
  }), (h > o.width || u > o.height) && e.push({
    code: f,
    message: `Your photo must be no larger than ${o.width}px x ${o.height}px.`
  }), e.length > 0 && r.push({
    file: n,
    errors: e
  }), r;
}, []);
export {
  z as convertHumanSize,
  w as customValidatorImage,
  M as iconBuilder
};
